import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { Observable } from "rxjs/Rx";

import { User } from "../_models/index";
import { environment } from "../../../environments/environment";
import { Utils } from "../../utils";

@Injectable()
export class UserService {
    constructor(private http: Http) {
    }

    verify() {
        return this.http.get(environment.URL_SERVER + "checksession", this.jwt()).map((response: Response) => response.json())
    }

    forgotPassword(email: string) {
        return this.http.post(environment.URL_SERVER, JSON.stringify({ email }), this.jwt()).map((response: Response) => response.json());
    }

    getAll() {
        return this.http.get('/api/users', this.jwt()).map((response: Response) => response.json());
    }

    getById(id: number) {
        return this.http.get('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    create(user: User) {
        return this.http.post(environment.URL_SERVER + "signup", user, this.jwt()).map((response: Response) => response.json());
    }

    update(user: User) {
        return this.http.put('/api/users/' + user.id, user, this.jwt()).map((response: Response) => response.json());
    }

    // delete(id: number) {
    //     return this.http.delete('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    // }

    getSessionUser() {
        return JSON.parse(localStorage.getItem('currentUser'));
    }



    // private helper methods

    private jwt() {
        // create authorization header with jwt token
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            headers.append("Authorization", 'Bearer ' + currentUser.token);
        }
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/user.service.ts